import * as R from 'ramda';
import React, {Component} from 'react';
import classNames from 'classnames';
import moment from 'moment';
import {exists} from 'js/common/object_helper';

import './index.scss';

export default class ExplicitDatePicker extends Component {
    static displayName = 'ExplicitDatePicker';

    constructor(props) {
        super(props);

        const initialDate = props.value ? moment(props.value) : null;

        const year = initialDate ? initialDate.year() : null;
        const month = initialDate ? initialDate.month() : null;
        const day = initialDate ? initialDate.date() : null;

        this.state = {
            year,
            month,
            day,
            hasError: false
        };

        if (this.getDate()) this.props.onChange(this.getDate());
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            prevState.year !== this.state.year ||
            prevState.month !== this.state.month ||
            prevState.day !== this.state.day
        ) {
            this.props.onChange(this.getDate());
        }
    }

    handleChange = (key, e) => {
        const value = parseInt(e.target.value, 10);
        if (!Number.isNaN(value)) {
            this.setState({[key]: value});
        }
    };

    renderMonthOptions = () =>
        R.pipe(
            R.addIndex(R.map)((m, i) => (
                <option key={i} value={i}>
                    {m}
                </option>
            )),
            R.prepend(<option key="placeholder">Month</option>)
        )(moment.months());

    renderDayOptions = () => {
        const {month} = this.state;
        const days = month
            ? moment()
                  .month(month)
                  .daysInMonth()
            : 31;
        return R.pipe(
            R.map(i => (
                <option key={i} value={i}>
                    {i}
                </option>
            )),
            R.prepend(<option key="placeholder">Day</option>)
        )(R.range(1, days + 1));
    };

    renderYearOptions = () => {
        const year = moment().get('year');
        return R.pipe(
            R.map(i => (
                <option key={i} value={i}>
                    {i}
                </option>
            )),
            R.reverse,
            R.prepend(<option key="placeholder">Year</option>)
        )(R.range(year - 100, year + 1));
    };

    getDate = () => {
        const initialDate = R.props(['year', 'month', 'day'], this.state);

        if (R.all(exists, initialDate)) {
            return moment(initialDate).format('YYYY-MM-DD');
        }

        return null;
    };

    render() {
        const {year, month, day, hasError} = this.state;
        const {label} = this.props;

        return (
            <div className={classNames('form-group', hasError && 'has-error')}>
                <label className="control-label">{label}</label>
                <div className="checkbox date-container">
                    <div className="date-picker">
                        <select
                            className="date-month"
                            onChange={R.partial(this.handleChange, ['month'])}
                            defaultValue={month}
                        >
                            {this.renderMonthOptions()}
                        </select>
                        <select
                            className="date-day"
                            onChange={R.partial(this.handleChange, ['day'])}
                            defaultValue={day}
                        >
                            {this.renderDayOptions()}
                        </select>
                        <select
                            className="date-year"
                            onChange={R.partial(this.handleChange, ['year'])}
                            defaultValue={year}
                        >
                            {this.renderYearOptions()}
                        </select>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/explicit_date_picker/index.js